import './image.style.sass';
import template from './image.tpl.pug';

class ImageController {
    /* @ngInject */
    constructor($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
    }

    $onInit() {
        this.initialize();
        this.wrappedUrl = null;

        this.image = this.$element.find('img');

        this.image
            .on('load', this.successHandler.bind(this))
            .on('error', this.errorHandler.bind(this));
    }

    $onDestroy() {
        this.image
            .off('load', this.successHandler.bind(this))
            .off('error', this.errorHandler.bind(this));
    }

    $onChanges(changeObject) {
        if (changeObject.url) {
            this.initialize();
            this.url = changeObject.url.currentValue;
        }
    }

    initialize() {
        this.loading = true;
        this.missing = false;
    }

    successHandler() {
        this.updateImage(this.url);
    }

    errorHandler() {
        this.updateImage();
    }

    updateImage(url) {
        this.$scope.$applyAsync(() => {
            this.loading = false;
            this.missing = !url;
            this.wrappedUrl = this.missing ? null : `url("${url}")`;

            this.onChange({
                url
            });
        });
    }
}

export default {
    selector: 'dbImage',
    template: template(),
    controller: ImageController,
    bindings: {
        url: '<',
        color: '<',
        alt: '<',
        onChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/image/image.cmpt.js